import React from 'react'
import shoppingCar from '../../../assets/images/shopping-car.svg'
import { storeURL } from '../../../constants/activity-constants'
import './shoppingCar.scss'

const ShoppingCar = () => {
  return (
    <a
      onClick={() => {
        try {
          window.dataLayer.push({
            event: 'ga_event',
            category: 'ui :: landing',
            action: 'click',
            label: 'comprar',
            value: '',
          })
        } catch (error) {
          console.log(error)
        }
      }}
      href={storeURL}
      target="_blank"
    >
      <div className="f-shopping-container">
        <img
          className="f-shopping-container__icon"
          src={shoppingCar}
          alt="logo boton carrito"
        />
        <span className="test">Comprar toallas</span>
      </div>
    </a>
  )
}

export default ShoppingCar
